<script setup>
import { ref } from 'vue'
import { UUID } from '@/modules/util/uuid'

const id = new UUID().get()
const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])

const colour = props.field.color ? props.field.color : 'primary'

const switchId = (option, i) => {
	return `${id}-${option.value}-${i}`
}

const clickItem = (option, i) => {
	document.getElementById(switchId(option, i)).click()
}
</script>

<template>
<v-list>
	<v-list-subheader class="px-2">
		{{ field.label }}
	</v-list-subheader>
	<v-list-item
		v-for="option, i in field.options"
		:key="option.value"
		class="px-0"
		:ripple="false"
		@click.stop="clickItem(option, i)"
	>
		<v-list-item-action class="px-4">
			<v-switch
				:id="switchId(option, i)"
				:label="option.label"
				:value="option.value"
				:color="colour"
				:model-value="modelValue"
				hide-details="auto"
				multiple
				@click.stop
				@update:model-value="(val) => emit('update:modelValue', val)"
			/>
		</v-list-item-action>
	</v-list-item>
</v-list>
</template>

<style lang="scss" scoped>
</style>